export default __webpack_public_path__ + "static/data-vis-adjacent-color-dont-light-8cef45143675391ebfc9c8b3a5e7ea8a.png";